import React, { useState, useEffect } from "react";
import "./ClientManagement.scss";

export interface Client {
    id: string;
    name: string;
    email: string;
    phone: string;
    address: string;
    description: string;
    responsibleEmployee?: string;
}

interface ClientDetailSidebarFormProps {
    client?: Client;
    onClose: () => void;
    onSave: (client: Client) => void;
}


// Dummy-Daten für die Liste der Mitarbeiter
const employees = [
    { id: "1", name: "Peter Meier" },
    { id: "2", name: "Petra Schmidt" },
    { id: "3", name: "Peter Schneider" },
    { id: "4", name: "Hans Schmidt" },
    { id: "5", name: "Maria Müller" },
];

const ClientDetailSidebarForm: React.FC<ClientDetailSidebarFormProps> = ({
    client,
    onClose,
    onSave,
}) => {
    const [name, setName] = useState<string>(client ? client.name : "");
    const [email, setEmail] = useState<string>(client ? client.email : "");
    const [phone, setPhone] = useState<string>(client ? client.phone : "");
    const [address, setAddress] = useState<string>(client ? client.address : "");
    const [description, setDescription] = useState<string>(client ? client.description : "");
    const [responsibleEmployee, setResponsibleEmployee] = useState<string>(
        client && client.responsibleEmployee ? client.responsibleEmployee : ""
    );

    useEffect(() => {
        if (client) {
            setName(client.name);
            setEmail(client.email);
            setPhone(client.phone);
            setAddress(client.address);
            setDescription(client.description);
            setResponsibleEmployee(client.responsibleEmployee || "");
        }
    }, [client]);

    const handleSave = () => {
        if (name.trim() === "") {
            alert("Der Name darf nicht leer sein!");
            return;
        }
        const newClient: Client = {
            id: client?.id || "",
            name,
            email,
            phone,
            address,
            description,
            responsibleEmployee,
        };
        onSave(newClient);
    };

    return (
        <div className="detail-sidebar-right">
            <div className="sidebar-header">
                <h2>{client ? "Klient bearbeiten" : "Neuen Klienten hinzufügen"}</h2>
                <i className="fa-solid fa-close" onClick={onClose} />
            </div>
            <div className="sidebar-content">
                <div className="input-group">
                    <label>Name</label>
                    <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="Name des Klienten eingeben"
                    />
                </div>
                <div className="input-group">
                    <label>E-Mail</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="E-Mail-Adresse eingeben"
                    />
                </div>
                <div className="input-group">
                    <label>Telefon</label>
                    <input
                        type="tel"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        placeholder="Telefonnummer eingeben"
                    />
                </div>
                <div className="input-group">
                    <label>Adresse</label>
                    <input
                        type="text"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                        placeholder="Adresse eingeben"
                    />
                </div>
                <div className="input-group">
                    <label>Beschreibung</label>
                    <textarea
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        placeholder="Weitere Informationen über den Klienten..."
                    />
                </div>
                <div className="input-group">
                    <label>Zuständiger Mitarbeiter</label>
                    <select
                        value={responsibleEmployee}
                        onChange={(e) => setResponsibleEmployee(e.target.value)}
                    >
                        <option value="">Bitte wählen</option>
                        {employees.map((employee) => (
                            <option key={employee.id} value={employee.name}>
                                {employee.name}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <div className="sidebar-actions">
                <button onClick={handleSave}>Speichern</button>
                <button onClick={onClose} className="cancel-button">Abbrechen</button>
            </div>
        </div>
    );
};

export default ClientDetailSidebarForm;
